import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { Textarea } from "@buildpy/ui/textarea";
import { DEMO_NO_SAVE_MESSAGE } from "@buildpy/core/modules/demo/routes";

// 고객 대화 입력칸의 데모판 — 모양은 MessageCompose 와 같고 보내기는 토스트만 띄운다.
const DemoMessageCompose = () => {
  const [body, setBody] = useState("");
  return (
    <form
      className="flex flex-col gap-y-2"
      data-testid="demo-message-form"
      onSubmit={(event) => {
        event.preventDefault();
        toast(DEMO_NO_SAVE_MESSAGE);
      }}>
      <Textarea
        aria-label="대화 내용"
        className="min-h-[88px]"
        placeholder="담당자에게 남길 말을 적어 주세요"
        value={body}
        onChange={(event) => setBody(event.target.value)}
      />
      <div className="flex justify-end">
        <Button disabled={body.trim() === ""} type="submit">
          보내기
        </Button>
      </div>
    </form>
  );
};

export default DemoMessageCompose;
